import axios from "axios";
//import config from "./config";
import { CASINO_ROOT as baseUrl } from '../configs/api';
import { SPORTBATTLEBASE_ROOT as sportBattleBaseUrl } from '../configs/api';
import { isDev, OPERATOR_ID } from "../configs/const";

let games = {};

// const baseUrl = baseUrl;

games.getGames = async () => {
  const url = `${baseUrl}casino/games/QT5`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getEnglishGames = async () => {
  const url = `${baseUrl}casino/games/DRC`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getIndianCasino = async () => {
  const url = `${baseUrl}casino/games/LOTUS`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getEvolveCasino = async () => {
  const url = `${baseUrl}casino/games/EVOLUTION`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getIndianCasino2 = async () => {
  const url = `${baseUrl}casino/lobby/SUPERNOVA`;//`${baseUrl}casino/games/SUPERNOVA`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      return res;
    }
    else {
      // const res = await axios(url);
      const res = await axios({
        method: 'post',
        url: url
      });
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getIndividualGame = async (gameId) => {
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const url = `${baseUrl}casino/games/launch/${gameId}`;
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      let token = JSON.parse(localStorage.getItem('userAuthDetail'))	
      token = token.token
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': {OPERATOR_ID}
      }
      const url = `${baseUrl}casino/games/launch/${gameId}`;
      const res = await axios(url, { headers: headers });
      console.log(res)
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }

}

games.getEvolutionCasino = async () => {
  const url = `${baseUrl}casino/lobby/EVOLUTION`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      // debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      // debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getDigitainSportBook = async () => {
  const url = `${baseUrl}casino/lobby/DIGITAIN`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      // debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      // debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getVivoCasino = async () => {
  const url = `${baseUrl}casino/lobby/VIVO`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getPragmaticCasino = async () => {
  const url = `${baseUrl}casino/games/PRAGMATIC`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getDRCRoyalGames = async () => {
  const url = `${baseUrl}casino/games/DRCROYAL`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getBetGamesCasino = async () => {
  const url = `${baseUrl}casino/lobby/BETGAMES`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getWACCasino = async () => {
  const url = `${baseUrl}casino/games/WAC`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getDRCHUDGames = async () => {
  const url = `${baseUrl}casino/games/DRCHUD`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}



games.getLudoCricketCasino = async () => {
  const url = `${baseUrl}casino/lobby/LUDOCRICKET`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getSPRIBEGames = async () => {
  const url = `${baseUrl}casino/games/SPRIBE`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}



games.getSpribeRdCasino = async () => {
  const url = `${baseUrl}casino/lobby/SPRIBE_RD`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      // const res = await axios.post(url, { headers: headers });
      const res = await axios({
        method: 'post',
        url: url,
        //data: payload, // you are sending body instead
        headers: headers,
      })
      // debugger
      return res;
    }
    else {
      const res = await axios({
        method: 'post',
        url: url
      });
      // debugger
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getMac88Casino = async () => {
  const url = `${baseUrl}casino/games/MAC88_LD`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getSTUDIO21Games = async () => {
  const url = `${baseUrl}casino/games/STUDIO21`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

games.getSportBattleUrl = async (eventId) => {
  const url = !!eventId ? `${sportBattleBaseUrl}games/launch/${eventId}` : `${sportBattleBaseUrl}games/lobby`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    debugger;
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    debugger;
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator,
        'Host': window.location.origin
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}



games.getInOutCasino = async () => {
  const url = `${baseUrl}casino/games/INOUT`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}


games.getUNIVERSESTUDIOCasino = async () => {
  const url = `${baseUrl}casino/games/UNIVERSESTUDIO`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}


games.getRVGAMESCasino = async () => {
  const url = `${baseUrl}casino/games/RVGAMES`;
  try {
    const name = window.name;
    let operator = "";
    let token = "";
    if (!!name) {
      const data = window.localStorage.getItem(name);
      if (!!data) {
        const tokenData = JSON.parse(data);
        operator = tokenData.operator;
        token = tokenData.token;
      }
    }
    else {
      operator = window.localStorage.getItem("operator");
      token = window.localStorage.getItem("token");
    }
    if (!!operator && !!token && operator !== "" && token !== "") {
      const headers = {
        'Authorization': `Bearer ${token}`,
        'X-OP-KEY': operator
      }
      const res = await axios(url, { headers: headers });
      return res;
    }
    else {
      const res = await axios(url);
      return res;
    }
  } catch (e) {
    console.log(e);
    return false;
  }
}

export default games;